module.exports = __webpack_public_path__ + "static/media/about-hero-mobile-750x380.f4c6a44e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/aboutUs/assets/about-hero-mobile-750x380.jpg
// module id = 1304
// module chunks = 1